import { CMDBaseResult } from "./CMDBaseResult"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDDragontiger implements ICommand
{

	public BaseResult : CMDBaseResult;
	public DragonCard : number = 0;
	public TigerCard : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.BaseResult = new CMDBaseResult();
		this.BaseResult.fromBytes(ba);
		this.DragonCard = ba.readUint8();
		this.TigerCard = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		let tempBuf0 = this.BaseResult.toBytes().toBuffer();
		ba.appendBuf(tempBuf0)
		ba.writeUint8(this.DragonCard);
		ba.writeUint8(this.TigerCard);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDDragontiger();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'BaseResult(CMDBaseResult)='+this.BaseResult+' ';
		str += 'DragonCard(B)='+this.DragonCard+' ';
		str += 'TigerCard(B)='+this.TigerCard+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'Dragontiger';
	}

}
